import { useCookies } from 'react-cookie';
import { BOTTOM_DRAWER_KEY, COOKIE_DATE_OFFSET } from './constants';

export const useBottomDrawerCookie = () => 
{
    const [ cookies, setCookie] = useCookies([`${BOTTOM_DRAWER_KEY}`]);
    const bottomDrawerCookie = cookies[ BOTTOM_DRAWER_KEY ];

    const setBottomDrawerCookie = (options) => 
    {
        setCookie(`${BOTTOM_DRAWER_KEY}`, { isClosed: true, ...options }, {
            path: '/', // make accessible for all pages
            expires: new Date( Date.now() + COOKIE_DATE_OFFSET ),
        });
    };

    return {
        bottomDrawerCookie,
        setBottomDrawerCookie,
    };
};
